<template>
  <div>
    <div class="xuanfu animate__animated animate__fadeInBottomRight">
      <div class="bear">
        <img
          :src="bear"
          alt=""
          @mouseover="bear = require('../assets/index/bearMove.gif')"
          @mouseleave="bear = require('../assets/index/bear.png')"
        />
      </div>
      <div
        class="phone"
        @mouseleave="
          (showEwm = false),
            (showNumber = false),
            (bear = require('../assets/index/bear.png'))
        "
      >
        <div
          class="mobile"
          @mouseover="
            (showNumber = true),
              (showEwm = false),
              (bear = require('../assets/index/bearMove.gif'))
          "
        >
          <img
            :src="
              showNumber
                ? require('../assets/index/phoneActive.png')
                : require('../assets/index/phone.png')
            "
            alt=""
          />
          <img
            v-if="showNumber"
            class="phoneNumber"
            src="../assets/index/phoneNumber.png"
            alt=""
          />
        </div>
        <div
          class="wechat"
          @mouseover="
            (showEwm = true),
              (showNumber = false),
              (bear = require('../assets/index/bearMove.gif'))
          "
        >
          <img
            :src="
              showEwm
                ? require('../assets/index/wechatActive.png')
                : require('../assets/index/wechat.png')
            "
            alt=""
          />
          <img
            v-if="showEwm"
            class="ewm"
            src="../assets/index/ewm.png"
            alt=""
          />
        </div>
        <div
          class="up"
          @click="goTop"
          @mouseover="
            (showEwm = false),
              (showNumber = false),
              (bear = require('../assets/index/bear.png'))
          "
        >
          <img src="../assets/index/up.png" alt="" />
        </div>
      </div>
      <!--            <div class="shouqi"><img src="../../assets/index/phone.png" alt=""></div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "XFK",
  props: {
    top: {
      type: String,
      default: "",
    },
  },
  watch: {
    top(val) {
      // console.log(val);
    },
  },
  data() {
    return {
      showNumber: false,
      showEwm: false,
      bear: require("../assets/index/bear.png"),
      show: true,
    };
  },
  methods: {
    goTop() {
      cancelAnimationFrame(this.timer);
      const self = this;
      self.timer = requestAnimationFrame(function fn() {
        const oTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop =
            oTop - 50;
          self.timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(self.timer);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.xuanfu {
  position: fixed;
  right: 0;
  z-index: 10;
  top: 179px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  .bear {
    width: 263px !important;
    height: 457px !important;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .phone {
    cursor: pointer;
    position: relative;
    margin-top: -6px;
    width: 55px;
    /*height: 185px;*/
    height: 185px;
    /*overflow: hidden;*/
    background: #ffffff;
    border-radius: 50px;
    /*&:hover{*/
    /*    height: 185px;*/
    /*    transition: height 1s;*/
    /*}*/
    .mobile,
    .up {
      width: 55px;
      height: 65px;
    }
    .mobile {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50px 50px 0 0;
      .phoneNumber {
        position: absolute;
        width: 185px;
        height: 65px;
        right: 60px;
      }
      &::after {
        content: "";
        width: 31px;
        height: 1px;
        background: #333;
        position: absolute;
        top: 65px;
      }
      img {
        width: 23px;
        height: 23px;
      }
    }
    .wechat {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 55px;
      height: 55px;
      position: relative;
      .ewm {
        width: 185px;
        height: 185px;
        position: absolute;
        right: 60px;
      }
      img {
        width: 25px;
        height: 21px;
      }
    }
    .up {
      border-radius: 0 0 50px 50px;
      background: #004c31;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 25px;
        height: 25px;
      }
    }
    /*img{*/
    /*    width: 50px !important;*/
    /*    height: 121px !important;*/
    /*}*/
  }
}
@media screen and (max-width: 450px) {
  .xuanfu {
    position: fixed;
    right: 0;
    z-index: 12;
    top: 179 * 2px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .bear {
      width: 263 * 2px !important;
      height: 457 * 2px !important;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .phone {
      cursor: pointer;
      position: relative;
      margin-top: -6 * 2px;
      width: 55 * 2px;
      /*height: 185px;*/
      height: 185 * 2px;
      /*overflow: hidden;*/
      background: #ffffff;
      border-radius: 50px;
      /*&:hover{*/
      /*    height: 185px;*/
      /*    transition: height 1s;*/
      /*}*/
      .mobile,
      .up {
        width: 55 * 2px;
        height: 65 * 2px;
      }
      .mobile {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50px 50px 0 0;
        .phoneNumber {
          position: absolute;
          width: 185 * 2px;
          height: 65 * 2px;
          right: 60 * 2px;
        }
        &::after {
          content: "";
          width: 31 * 2px;
          height: 1px;
          background: #333;
          position: absolute;
          top: 65 * 2px;
        }
        img {
          width: 23 * 2px;
          height: 23 * 2px;
        }
      }
      .wechat {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 55 * 2px;
        height: 55 * 2px;
        position: relative;
        .ewm {
          width: 185 * 2px;
          height: 185 * 2px;
          position: absolute;
          right: 60 * 2px;
        }
        img {
          width: 25 * 2px;
          height: 21 * 2px;
        }
      }
      .up {
        border-radius: 0 0 50px 50px;
        background: #004c31;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 25 * 2px;
          height: 25 * 2px;
        }
      }
      /*img{*/
      /*    width: 50px !important;*/
      /*    height: 121px !important;*/
      /*}*/
    }
  }
}
@media screen and (max-width: 450px) {
  .xuanfu {
    top: 179 * 6px;
    .bear {
      width: 263 * 1.3px !important;
      height: 457 * 1.3px !important;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
